var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91 7.266a1 1 0 00-1.414.057l-3.23 3.5a1 1 0 000 1.356l3.23 3.5a1 1 0 001.47-1.356L8.284 12.5H18a1 1 0 100-2H8.284l1.682-1.822a1 1 0 00-.057-1.413z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuOTA5MDYgNy4yNjYxOEM5LjUwMzI0IDYuODkxNTggOC44NzA1OCA2LjkxNjg4IDguNDk1OTcgNy4zMjI3TDUuMjY1MiAxMC44MjI3QzQuOTExNiAxMS4yMDU3IDQuOTExNiAxMS43OTYyIDUuMjY1MTkgMTIuMTc5Mkw4LjQ5NTk3IDE1LjY3OTNDOC44NzA1NyAxNi4wODUxIDkuNTAzMjMgMTYuMTEwNCA5LjkwOTA1IDE1LjczNThDMTAuMzE0OSAxNS4zNjEyIDEwLjM0MDIgMTQuNzI4NSA5Ljk2NTU4IDE0LjMyMjdMOC4yODM5NyAxMi41MDA5TDE4IDEyLjUwMDlDMTguNTUyMyAxMi41MDA5IDE5IDEyLjA1MzIgMTkgMTEuNTAwOUMxOSAxMC45NDg3IDE4LjU1MjMgMTAuNTAwOSAxOCAxMC41MDA5TDguMjg0IDEwLjUwMDlMOS45NjU1NyA4LjY3OTI3QzEwLjM0MDIgOC4yNzM0NSAxMC4zMTQ5IDcuNjQwNzkgOS45MDkwNiA3LjI2NjE4WiIgLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };